<template>
  <WebChapterTemplate
    page-title="《新闻与传播研究》"
    section-label="传播与平台"
    section-route="/lanhu_chuanboyupingtai"
    :top-strip-image="topStripImage"
    :hero-background-image="heroBackgroundImage"
  >
    <section class="page-section">
      <article class="content-card content-card--feature">
        <div class="intro-grid">
          <div class="intro-copy">
            <p class="eyebrow">传播平台</p>
            <h2 class="section-title">《新闻与传播研究》</h2>

            <p class="body-text">
              其前身为创办于 1979 年的《新闻研究资料》。《新闻与传播研究》创办于 1994 年，初为季刊，2008 年改为双月刊，2013 年改为月刊，截至 2018 年第 10 期，已连续出版 158 期。该刊以"代表中国新闻学、传播学学术研究的最高水平，引领中国新闻学、传播学学术研究的发展方向"为办刊追求，2013 年被列为国家社科基金资助期刊，2014 年被中国社会科学评价中心评定为"顶级期刊"，2015 年、2017 年两度被国家新闻出版广电总局推荐为全国"百强报刊"，2018 年被中国期刊协会评为学术类"期刊数字影响力 100 强"。
            </p>

            <p class="body-text">
              《新闻研究资料》系《新闻与传播研究》的前身，创办于 1979 年，至 1993 年终刊，共出版 61 辑。
            </p>

            <ul class="milestone-list">
              <li><strong>1979</strong><span>《新闻研究资料》创办</span></li>
              <li><strong>1994</strong><span>《新闻与传播研究》正式创刊</span></li>
              <li><strong>2008</strong><span>由季刊调整为双月刊</span></li>
              <li><strong>2013</strong><span>改为月刊并入选国家社科基金资助期刊</span></li>
              <li><strong>2018</strong><span>获评学术类“期刊数字影响力 100 强”</span></li>
            </ul>
          </div>

          <figure class="feature-figure">
            <img :src="images.collage" alt="《新闻与传播研究》历年期刊合影" />
            <figcaption>《新闻与传播研究》历年期刊合影</figcaption>
          </figure>
        </div>

        <div class="cover-wall">
          <figure class="cover-figure">
            <img :src="images.xinwenZiliao" alt="《新闻研究资料》创刊号封面" />
            <figcaption>《新闻研究资料》创刊号封面</figcaption>
          </figure>
          <figure class="cover-figure">
            <img :src="images.chuangkan1994" alt="《新闻与传播研究》1994 年创刊号封面" />
            <figcaption>《新闻与传播研究》1994 年创刊号封面</figcaption>
          </figure>
          <figure class="cover-figure">
            <img :src="images.shuangyuekan2008" alt="2008 年改为双月刊封面" />
            <figcaption>2008 年改为双月刊封面</figcaption>
          </figure>
          <figure class="cover-figure">
            <img :src="images.yuekan2013" alt="2013 年改为月刊封面" />
            <figcaption>2013 年改为月刊封面</figcaption>
          </figure>
          <figure class="cover-figure">
            <img :src="images.xuekan1985" alt="《新闻学刊》创刊于 1985 年，1989 年停刊" />
            <figcaption>《新闻学刊》创刊于 1985 年，1989 年停刊</figcaption>
          </figure>
        </div>
      </article>
    </section>

    <section class="page-section">
      <article class="content-card">
        <div class="card-header">
          <p class="eyebrow">学术影响</p>
          <h2 class="section-title">平台与荣誉</h2>
        </div>

        <div class="honor-showcase">
          <figure class="honor-figure honor-figure--platform">
            <img :src="images.onlinePlatform" alt="《新闻与传播研究》在线投审稿平台" />
            <figcaption>《新闻与传播研究》实行双向匿名评审，图为在线投审稿平台</figcaption>
          </figure>

          <figure class="honor-figure honor-figure--highlight">
            <img :src="images.cert100" alt="2018 年期刊数字影响力 100 强" />
            <figcaption>2018 年，《新闻与传播研究》被中国期刊协会评选为学术类"期刊数字影响力 100 强"</figcaption>
          </figure>
        </div>

        <div class="certificate-grid">
          <figure class="honor-figure">
            <img :src="images.baiqiang2015" alt="2015 年百强报刊荣誉证书" />
            <figcaption>2015 年，《新闻与传播研究》被国家新闻出版广电总局推荐为全国"百强报刊"</figcaption>
          </figure>

          <figure class="honor-figure">
            <img :src="images.baiqiang2017" alt="2017 年百强报刊荣誉证书" />
            <figcaption>2017 年，《新闻与传播研究》被国家新闻出版广电总局推荐为全国"百强报刊"</figcaption>
          </figure>
        </div>

        <figure class="conference-figure">
          <img :src="images.conference" alt="2015 年 10 月主编论坛主题发言" />
          <figcaption>2015 年 10 月，《新闻与传播研究》主编唐绪军在南京举办的"期刊发展与新闻传播学变革"主编论坛上做主题发言</figcaption>
        </figure>
      </article>
    </section>
  </WebChapterTemplate>
</template>

<script>
import WebChapterTemplate from '@/components/WebChapterTemplate.vue';

export default {
  name: 'NewLanhuXinwenyuchuanboyanjiu',
  components: {
    WebChapterTemplate
  },
  data() {
    return {
      topStripImage: require('@/views/lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png'),
      heroBackgroundImage: require('@/views/lanhu_zhengwenyexueshuchengguo/assets/img/173301bb9c6d42d7ae3028c182487260_mergeImage.png'),
      images: {
        collage: require('./assets/p60-collage.jpg'),
        xinwenZiliao: require('./assets/p60-xinwen-ziliao-chuangkan.jpg'),
        chuangkan1994: require('./assets/p60-1994-chuangkan.jpg'),
        shuangyuekan2008: require('./assets/p60-2008-shuangyuekan.jpg'),
        yuekan2013: require('./assets/p60-2013-yuekan.jpg'),
        xuekan1985: require('./assets/p60-xinwen-xuekan-1985.jpg'),
        onlinePlatform: require('./assets/p61-online-platform.jpg'),
        cert100: require('./assets/p61-100qiang-2018.jpg'),
        baiqiang2015: require('./assets/p61-baiqiang-2015.jpg'),
        baiqiang2017: require('./assets/p61-baiqiang-2017.jpg'),
        conference: require('./assets/p61-conference.jpg')
      }
    };
  }
};
</script>

<style scoped>
.page-section {
  margin-bottom: 40px;
}

.page-section:last-child {
  margin-bottom: 0;
}

.content-card {
  padding: 32px;
  border-radius: 12px;
  border: 1px solid rgba(179, 145, 101, 0.18);
  background:
    linear-gradient(140deg, rgba(248, 242, 233, 0.82), rgba(255, 255, 255, 0) 42%),
    linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(251, 249, 245, 0.96));
  box-shadow: 0 16px 34px rgba(59, 41, 17, 0.06);
}

.content-card--feature {
  background:
    radial-gradient(circle at top right, rgba(242, 92, 25, 0.08), rgba(255, 255, 255, 0) 32%),
    linear-gradient(140deg, rgba(248, 242, 233, 0.86), rgba(255, 255, 255, 0) 48%),
    linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(251, 249, 245, 0.96));
}

.eyebrow {
  margin: 0 0 10px;
  color: #b28a56;
  font-size: 12px;
  line-height: 1.4;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.card-header {
  margin-bottom: 22px;
}

.section-title {
  margin: 0 0 16px;
  color: #f25c19;
  font-size: 24px;
  line-height: 1.4;
  font-weight: 700;
  font-family: 'Songti SC', 'STSong', 'Noto Serif SC', serif;
}

.body-text {
  margin: 0 0 14px;
  color: #231f20;
  font-size: 15px;
  line-height: 1.9;
  text-align: justify;
  text-indent: 2em;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.intro-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(280px, 0.88fr);
  gap: 28px;
  align-items: start;
}

.intro-copy {
  min-width: 0;
}

.feature-figure,
.cover-figure,
.honor-figure,
.conference-figure {
  margin: 0;
}

.feature-figure img,
.cover-figure img,
.honor-figure img,
.conference-figure img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 6px;
  box-shadow: 0 10px 28px rgba(52, 34, 14, 0.1);
}

.feature-figure figcaption,
.cover-figure figcaption,
.honor-figure figcaption,
.conference-figure figcaption {
  margin-top: 10px;
  color: #6f6253;
  font-size: 12px;
  line-height: 1.6;
  text-align: center;
}

.milestone-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 14px;
  margin: 20px 0 0;
  padding: 0;
  list-style: none;
}

.milestone-list li {
  display: grid;
  grid-template-columns: 54px minmax(0, 1fr);
  gap: 10px;
  align-items: baseline;
  padding: 12px 14px;
  border-radius: 10px;
  background: rgba(255, 248, 239, 0.85);
  border: 1px solid rgba(242, 92, 25, 0.08);
}

.milestone-list strong {
  color: #f25c19;
  font-size: 20px;
  line-height: 1;
  font-weight: 700;
}

.milestone-list span {
  color: #4a3b2a;
  font-size: 13px;
  line-height: 1.6;
}

.cover-wall {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 16px;
  margin-top: 28px;
}

.honor-showcase {
  display: grid;
  grid-template-columns: minmax(0, 1.16fr) minmax(280px, 0.84fr);
  gap: 20px;
  align-items: stretch;
}

.honor-figure--platform,
.honor-figure--highlight {
  padding: 18px;
  border-radius: 12px;
  background: rgba(255, 252, 247, 0.92);
  border: 1px solid rgba(179, 145, 101, 0.16);
}

.certificate-grid {
  display: grid;
  grid-template-columns: minmax(0, 0.86fr) minmax(0, 1.14fr);
  gap: 20px;
  margin-top: 20px;
}

.certificate-grid .honor-figure {
  padding: 18px;
  border-radius: 12px;
  background: rgba(255, 252, 247, 0.92);
  border: 1px solid rgba(179, 145, 101, 0.16);
}

.conference-figure {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px dashed rgba(179, 145, 101, 0.35);
}

.conference-figure img {
  max-width: 920px;
  margin: 0 auto;
}

@media (max-width: 1200px) {
  .cover-wall {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 1024px) {
  .intro-grid,
  .honor-showcase,
  .certificate-grid {
    grid-template-columns: 1fr;
  }

  .feature-figure img {
    max-width: 560px;
    margin: 0 auto;
  }
}

@media (max-width: 768px) {
  .content-card {
    padding: 20px;
  }

  .milestone-list,
  .cover-wall {
    grid-template-columns: 1fr;
  }

  .milestone-list li {
    grid-template-columns: 48px minmax(0, 1fr);
  }
}
</style>
